<template>
  <v-card flat>
    <v-card-title>
      <span class="headline">Login</span>
    </v-card-title>
    <v-card-text>
      <v-form v-model="valid" ref="form" @submit.prevent="handleLogin">
        <v-text-field
          v-model="identifier"
          :rules="emailRules"
          label="E-mail"
          required
        ></v-text-field>

        <v-text-field
          name="password"
          v-model="password"
          label="Enter your password"
          min="8"
          :rules="[passwordRules.required, passwordRules.min]"
          counter
          type="password"
        ></v-text-field>

        <div class="text-center">
          <v-btn
            type="submit"
            color="#FC4A46"
            class="login-button"
            x-large
            :disabled="!valid"
            >Login</v-btn
          >
        </div>
      </v-form>

      <!-- <small>*indicates required field</small> -->
    </v-card-text>
    <v-card-actions> </v-card-actions>
  </v-card>
</template>

<script>
import { authComputed } from '@/store/helpers';

export default {
  data: () => ({
    identifier: '',
    password: '',
    token: '',
    error: false,
    valid: false,
    emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /.+@.+/.test(v) || 'E-mail must be valid',
    ],
    passwordRules: {
      //TODO: Change to 8
      required: (value) => !!value || 'Required.',
      min: (v) => v.length >= 7 || 'Min 7 characters',
    },
  }),
  methods: {
    handleLogin() {
      if (this.valid) {
        this.$store
          .dispatch('LOGIN', {
            identifier: this.identifier,
            password: this.password,
          })
          .then(() => {
            if (this.$store.getters.type === 'recruiter') {
              this.$router.push('/recruiter/job-posts ');
            } else {
              this.$router.go(this.$router.currentRoute);
            }
            this.handleClose();
          })
          .catch((error) => {
            console.log(error);
            this.error = true;
          });
      } else {
        return;
      }
    },
    test() {
      console.log(this.dialog);
      this.dialog = false;
    },
  },
  computed: {
    ...authComputed,
  },
  props: ['buttonText', 'color', 'dark', 'text', 'handleClose'],
};
</script>
<style lang="scss">
.v-btn.theme--light.login-button {
  color: #fff;
}
</style>
;
